module.exports = __webpack_public_path__ + "static/media/address-business-hover.18fe9b5f.svg";